import { render } from "./MainContent.vue?vue&type=template&id=c2c04aa4&scoped=true"
import script from "./MainContent.vue?vue&type=script&lang=js"
export * from "./MainContent.vue?vue&type=script&lang=js"

import "./MainContent.vue?vue&type=style&index=0&id=c2c04aa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2c04aa4"]])

export default __exports__